const ERRORS = {
    NOTMOREROW : 'No existen más registros en la lista seleccionada'
}

export default ERRORS;